import React from 'react';

const DisclaimerPolicy = () => {
  return (
    <div className="bg-slate-50 min-h-screen font-sans pb-20">

      {/* ── 1. HERO BANNER ── */}
      <div className="relative text-white overflow-hidden" style={{ minHeight: '300px' }}>
        <img src="/SG (6).jpg" alt="Disclaimer Policy" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#001529] via-[#0d2d6b]/90 to-[#0d2d6b]/60" />
        <div className="absolute top-0 right-0 opacity-5 text-[180px] font-black select-none leading-none -mr-8 -mt-8">SGCL</div>

        <div className="relative z-10 px-4 md:px-20 py-16 max-w-4xl">
          <span className="bg-govt-orange text-white px-4 py-1 rounded-full text-xs font-black uppercase tracking-widest">
            Disclaimer Statement
          </span>
          <h1 className="text-4xl md:text-5xl font-black mt-4 mb-5 leading-tight uppercase italic">
            Disclaimer <span className="text-govt-orange">Policy</span>
          </h1>
          <p className="text-blue-100 font-bold border-l-4 border-govt-orange pl-5 italic max-w-2xl leading-relaxed text-base">
            Important regulatory disclosures and clarification regarding the corporate status and operations of Shramjivi Goodshed Corporation Limited.
          </p>
        </div>

        {/* Tricolor border strip */}
        <div className="absolute bottom-0 left-0 right-0 h-1.5 flex">
          <div className="flex-1 bg-[#FF9933]" />
          <div className="flex-1 bg-white" />
          <div className="flex-1 bg-[#138808]" />
        </div>
      </div>

      {/* ── 2. CONTENT SECTION ── */}
      <div className="container mx-auto px-4 md:px-20 mt-12 max-w-5xl">
        <div className="bg-white rounded-3xl shadow-xl border border-slate-100 p-8 md:p-12 space-y-10 relative overflow-hidden">
          {/* Saffron accent border */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-[#FF9933]" />

          {/* Document Header */}
          <div className="border-b border-slate-100 pb-8">
            <h2 className="text-govt-blue font-black text-2xl uppercase tracking-wider">Disclaimer Policy</h2>
            <div className="mt-4 flex flex-col md:flex-row gap-4 text-xs font-bold text-slate-500 uppercase">
              <p>🌐 <span className="text-slate-700">Websites:</span> www.shramjivicorp.com / www.shramjivicorporation.co.in</p>
              <p>🏢 <span className="text-slate-700">Owned &amp; Operated By:</span> Shramjivi Goodshed Corporation Limited</p>
            </div>
          </div>

          {/* Content sections */}
          <div className="space-y-8 text-slate-600 text-sm leading-relaxed font-semibold">

            {/* Section 1 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">1.</span> General Disclaimer
              </h3>
              <p className="pl-6">
                The information contained on this website is provided in good faith for general informational, educational, and communication purposes only.
              </p>
              <p className="pl-6">
                While Shramjivi Goodshed Corporation Limited ("SGCL", "Company", "we", "our", or "us") makes reasonable efforts to ensure the accuracy and reliability of information published on this website, we make no representations or warranties of any kind, express or implied, regarding accuracy, completeness, reliability, availability, suitability, or timeliness of any information, services, documents, graphics, or materials contained on this website.
              </p>
              <p className="pl-6 font-bold text-red-600/90 italic">
                Users rely on such information entirely at their own discretion and risk.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 2 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">2.</span> No Professional or Legal Advice
              </h3>
              <p className="pl-6">
                The information available on this website shall not be construed as:
              </p>
              <ul className="pl-12 list-disc space-y-1 text-slate-700">
                <li>Legal advice</li>
                <li>Financial advice</li>
                <li>Tax advice</li>
                <li>Regulatory advice</li>
                <li>Government notification</li>
                <li>Railway Board instruction</li>
                <li>Official policy interpretation</li>
              </ul>
              <p className="pl-6 font-bold">
                Users are advised to consult appropriate professionals or competent authorities before acting upon any information obtained from this website.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 3 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2 text-red-600">
                <span className="text-govt-orange text-xl">3.</span> No Government Affiliation
              </h3>
              <div className="pl-6 space-y-3">
                <p className="font-bold text-slate-800">
                  Shramjivi Goodshed Corporation Limited is a private company incorporated under the Companies Act and registered with the Ministry of Corporate Affairs (MCA), Government of India.
                </p>
                <p>
                  Registration with MCA does not imply government ownership, control, endorsement, sponsorship, or authorization.
                </p>
                <p>
                  Unless specifically stated through an official agreement, notification, or authorization, the Company:
                </p>
                <ul className="pl-6 list-disc space-y-1 text-slate-700 font-bold">
                  <li>Is not a Government Department.</li>
                  <li>Is not part of Indian Railways.</li>
                  <li>Is not an agency of the Ministry of Railways.</li>
                  <li>Does not represent the Government of India.</li>
                </ul>
                <p className="text-xs text-slate-400 italic">
                  Any references to government programs, policies, ministries, railway zones, public authorities, or statutory institutions are provided solely for informational purposes.
                </p>
              </div>
            </section>

            <hr className="border-slate-100" />

            {/* Section 4 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">4.</span> Railway-Related Information Disclaimer
              </h3>
              <p className="pl-6">
                Information relating to Indian Railways, Railway Board, Railway Zones, Freight Operations, Goods Sheds, Railway Policies, and Government Schemes may be based on publicly available information obtained from official sources.
              </p>
              <p className="pl-6">
                Users should independently verify all information through the respective official authorities before making operational, legal, financial, or business decisions. Official policies, circulars, guidelines, and regulations may change without notice.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 5 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">5.</span> Proposal &amp; Vision Statement Disclaimer
              </h3>
              <p className="pl-6">
                Certain content published on this website may contain proposals, strategic plans, future objectives, operational concepts, development models, vision statements, or expansion plans.
              </p>
              <p className="pl-6">
                Such content represents the Company's views, aspirations, and proposed initiatives at the time of publication. These statements should not be interpreted as guarantees, commitments, approvals, or assurances of future implementation.
              </p>
              <p className="pl-6 text-xs text-slate-400 italic">
                Actual outcomes may vary depending upon regulatory approvals, operational feasibility, stakeholder participation, contractual arrangements, and applicable laws.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 6 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">6.</span> External Links Disclaimer
              </h3>
              <p className="pl-6">
                This website may contain hyperlinks to third-party websites, including government portals, public institutions, and external organizations. Examples may include National Portal of India, MyGov, Integrated Government Online Directory (IGOD), Ministry websites, Railway websites, and statutory authorities.
              </p>
              <p className="pl-6 font-bold text-slate-700">
                These links are provided solely for user convenience and informational purposes. The Company does not control and is not responsible for external website content, website availability, privacy policies, security practices, or information accuracy. Users access external websites entirely at their own risk.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 7 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">7.</span> National Portal, MyGov &amp; IGOD References
              </h3>
              <p className="pl-6">
                This website may provide references or hyperlinks to official Government of India platforms including National Portal of India (www.india.gov.in), MyGov (www.mygov.in), and Integrated Government Online Directory (www.igod.gov.in).
              </p>
              <p className="pl-6">
                Such references are intended solely to facilitate public access to government information and services. The inclusion of such references shall not be interpreted as government endorsement of SGCL, partnership with SGCL, approval of SGCL activities, or official affiliation.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 8 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">8.</span> Limitation of Liability
              </h3>
              <p className="pl-6">
                To the maximum extent permitted by applicable law, Shramjivi Goodshed Corporation Limited shall not be liable for any direct, indirect, incidental, consequential, business interruption, data loss, revenue loss, or reputation loss arising out of or related to:
              </p>
              <ul className="pl-12 list-disc space-y-1 text-slate-700">
                <li>Use of this website</li>
                <li>Reliance upon website information</li>
                <li>Technical interruptions</li>
                <li>External website access</li>
                <li>Errors or omissions in content</li>
              </ul>
            </section>

            <hr className="border-slate-100" />

            {/* Section 9 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">9.</span> Website Availability
              </h3>
              <p className="pl-6">
                The Company does not guarantee uninterrupted access to the website. Access may be suspended, restricted, delayed, or interrupted due to scheduled maintenance, technical failures, cybersecurity incidents, system upgrades, or events beyond reasonable control.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 10 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">10.</span> Copyright &amp; Intellectual Property
              </h3>
              <p className="pl-6">
                Unless otherwise stated, all content on this website including text, graphics, logos, documents, reports, designs, and branding materials is the property of Shramjivi Goodshed Corporation Limited and is protected under applicable intellectual property laws. Unauthorized reproduction, modification, distribution, or commercial use is prohibited.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 11 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">11.</span> Changes to Disclaimer
              </h3>
              <p className="pl-6">
                The Company reserves the right to amend, update, modify, or replace this Disclaimer Policy at any time without prior notice. Users are encouraged to review this page periodically for updates.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 12 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">12.</span> Contact Information
              </h3>
              <div className="pl-6 space-y-4">
                <p>Shramjivi Goodshed Corporation Limited</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs font-bold text-slate-700 bg-slate-50 p-6 rounded-2xl border border-slate-100 uppercase">
                  <div className="space-y-2">
                    <p>🌐 Website: www.shramjivicorp.com / www.shramjivicorporation.co.in</p>
                    <p>✉️ Email: support@shramjivicorp.com / info@shramjivicorporation.co.in</p>
                    <p>📞 Contact: +91 73659 61803 / +91 97070 55354</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-[10px] text-govt-orange">Registered Office:</p>
                    <p className="leading-relaxed">
                      D/14, Satyajit Roy Co-operative Market, Champasari More,<br />
                      Ward No. 46, Pradhan Nagar, Siliguri,<br />
                      Darjeeling, West Bengal – 734003
                    </p>
                  </div>
                </div>
              </div>
            </section>

          </div>

          {/* Saffron / Green tricolor banner at the bottom of card */}
          <div className="mt-10 pt-6 border-t border-slate-100 text-center text-[10px] font-black uppercase text-slate-400 tracking-widest leading-loose">
            Disclaimer: Use of this website constitutes acceptance of this Disclaimer Policy and all associated website policies. <br />
            © Shramjivi Goodshed Corporation Limited. All Rights Reserved.
          </div>

        </div>
      </div>
    </div>
  );
};

export default DisclaimerPolicy;
